/**
 * Die Route als React-Zustand.
 *
 * **Auf `hashchange` hören ist nicht Kosmetik.** Ein Spieler fügt einen Einladungslink in eine
 * offene Seite ein, oder klickt ihn in einem Chat, der die Seite nicht neu lädt. Ohne diesen
 * Hörer bliebe der Startbildschirm stehen, und der Link sähe aus, als funktioniere er nicht.
 */

import { useEffect, useState } from 'react';

import { parseFragment, type Route } from './fragment.js';

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseFragment(window.location.hash));

  useEffect(() => {
    const update = (): void => setRoute(parseFragment(window.location.hash));
    window.addEventListener('hashchange', update);
    // Einmal nachziehen: zwischen dem ersten Zeichnen und diesem Effekt kann sich das Fragment
    // geändert haben (ein Klick während des Ladens).
    update();
    return () => window.removeEventListener('hashchange', update);
  }, []);

  return route;
}
